import en from "./en";
const es = {
  ...en,
  nav: {
    home: "Inicio",
    about: "La Alianza",
    markets: "Mercados",
    services: "Servicios",
    partners: "Socios",
    manufacturers: "Para Fabricantes",
    news: "Noticias",
    contact: "Contacto",
    partner_cta: "Hazte Socio",
  },
  hero: {
    eyebrow: "European Electric Mobility Alliance",
    title_line1: "La plataforma europea de distribución",
    title_line2: "para la movilidad eléctrica",
    subtitle: "Conectamos a los fabricantes con la red de distribución más experimentada de Europa. No solo importamos vehículos. Construimos marcas.",
    cta_primary: "Hazte Socio",
    cta_secondary: "Descubre la Alianza",
    scroll: "Desplázate para descubrir",
  },
  cta_final: {
    eyebrow: "Asociación Estratégica",
    title: "¿Listo para expandirte por Europa?",
    subtitle: "Colabora con EEMA y aprovecha una plataforma comercial consolidada que cubre los mercados europeos más estratégicos de la movilidad eléctrica.",
    button: "Solicitar una reunión",
  },
};
export default es;
